import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';
import { Pagination } from 'antd';

import { Select } from '@/components/common/select';

import styles from './pagination-footer.module.scss';

export type PaginationFooterProps = {
  page: number;
  pageSize: number;
  total: number;
  pageSizeOptions?: number[];
  onChange: (page: number, pageSize: number) => void;
};

export function PaginationFooter({
  page,
  pageSize,
  total,
  pageSizeOptions = [10, 25, 50],
  onChange,
}: PaginationFooterProps) {
  if (total === 0) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className={styles.footer}>
      <div className={styles.showing}>
        <span>Showing</span>
        <Select
          selectSize="compact"
          aria-label="Rows per page"
          className={styles.rangeSelect}
          value={pageSize}
          options={pageSizeOptions.map((size) => ({ value: size, label: String(size) }))}
          labelRender={() => `${start}–${end}`}
          onChange={(size) => onChange(1, size as number)}
        />
        <span>of {total} results</span>
      </div>
      <Pagination
        className={styles.pager}
        current={page}
        pageSize={pageSize}
        total={total}
        showSizeChanger={false}
        onChange={(nextPage) => onChange(nextPage, pageSize)}
        itemRender={(_page, type, original) => {
          if (type === 'prev') {
            return (
              <span className={styles.nav}>
                <CaretLeftIcon size={14} aria-hidden />
              </span>
            );
          }
          if (type === 'next') {
            return (
              <span className={styles.nav}>
                <CaretRightIcon size={14} aria-hidden />
              </span>
            );
          }
          return original;
        }}
      />
    </div>
  );
}
